import { render, staticRenderFns } from "./tachistoscope.config.vue?vue&type=template&id=d8e51148"
import script from "./tachistoscope.config.vue?vue&type=script&lang=js"
export * from "./tachistoscope.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports